import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let mjlrouter = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/common/Home.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("./views/common/News.vue"),
      // meta: { keepAlive: true },
    },
    {
      path: "/newsdetails",
      name: "newsdetails",
      component: () => import("./views/common/NewsDetails.vue"),
    },
    {
      path: "/platform",
      name: "platform",
      component: () => import("./views/common/Platform.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/common/About.vue"),
    },
    {
      path: "/goin",
      name: "goin",
      component: () => import("./views/common/GoIn.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/platform-details",
      name: "platform-details",
      component: () => import("./views/common/platformDetails.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      Vue.nextTick(() => {
        // 获取 el-main 的 DOM 并滚动到顶部
        const elMain = document.querySelector(".el-main");
        if (elMain) {
          elMain.scrollTop = 0;
        }
        resolve({ x: 0, y: 0 }); // 同时触发全局滚动
      });
    });
  },
});

// 判断是否需要登录权限 以及是否登录
mjlrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some((res) => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem("token")) {
      next();
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default mjlrouter;
